<div class="customers-container">
  <!-- Section header: title, search and every list action on one row. Action
       order matches Orders, Products and Catalogs — filter, clear, download,
       columns, then the page's own actions, primary last (WB-7275).
       No (searchInput) binding: this page already drives search off the
       control's valueChanges. -->
  <ui-page-header
    [title]="'companies.company' | translate"
    [lucideIcon]="'Store'"
    [searchable]="true"
    searchTestId="companies-search"
    [searchControl]="searchInput"
    [searchPlaceholder]="'companies.filter.title' | translate"
  >
    <!-- Filter, with its clear badge (see ui-filter-action). -->
    <ui-filter-action
      [active]="hasModuleFilters()"
      (filter)="setFilter()"
      (clear)="clearFilter()"
    ></ui-filter-action>

    <!-- Download -->
    <button
      type="button"
      class="ui-header-action"
      [attr.aria-label]="'inventory.download' | translate"
      [matTooltip]="'inventory.download' | translate"
      matTooltipPosition="below"
      (click)="exportCompanies()"
    >
      <img src="assets/icones/download_icon.svg" alt="" />
    </button>

    <!-- Configure columns -->
    <ui-table-column-settings
      triggerIcon="sliders-horizontal"
      [columns]="pickerColumns"
      (columnsChange)="onColumnsChange($event)"
    ></ui-table-column-settings>

    <!-- Bulk actions for the current selection live in the floating
         ui-bulk-actions-bar at the bottom of the table, not here. -->

    <!-- Add company -->
    <ui-button
      *appHasPermission="{ module: 'company', action: 'create' }"
      type="primary"
      icon="plus-cc"
      [label]="'common.add' | translate"
      (click)="addCustomers()"
    ></ui-button>
  </ui-page-header>

  <div class="customers-content" [class.customers-content--with-bulk-bar]="selection.hasSelection">
    <table class="customers-table">
      <thead>
        <tr class="row header" [style.grid-template-columns]="gridTemplateColumns">
          <th class="cell-name" [style.order]="columnOrderIndex('name')">
            <ui-checkbox
              [checked]="selection.isAllSelected"
              [indeterminate]="selection.isPartialSelected"
              [ariaLabel]="'common.select_all' | translate"
              (changed)="selection.toggleAll($event.checked)">
            </ui-checkbox>
            <span style="display: flex; align-items: center;">
              {{ "companies.full_name_id" | translate }}
              <div class="sort-actions">
                <span class="arrow-up" [class.active]="activeSortBy == 'name' && activeSortMode == 'asc'" (click)="sortBy('name', 'asc')"></span>
                <span class="arrow-down" [class.active]="activeSortBy == 'name' && activeSortMode == 'desc'" (click)="sortBy('name', 'desc')"></span>
              </div>
            </span>
          </th>
          <!-- <th>Tags</th> -->
          <th *ngIf="isColumnVisible('locations')" [style.order]="columnOrderIndex('locations')">
            <span style="display: flex; align-items: center;">
              {{ "common.location" | translate }}
              <div class="sort-actions">
                <span class="arrow-up" [class.active]="activeSortBy == 'locations_count' && activeSortMode == 'asc'" (click)="sortBy('locations_count', 'asc')"></span>
                <span class="arrow-down" [class.active]="activeSortBy == 'locations_count' && activeSortMode == 'desc'" (click)="sortBy('locations_count', 'desc')"></span>
              </div>
            </span>
          </th>
          <th *ngIf="isColumnVisible('erp_id')" [style.order]="columnOrderIndex('erp_id')">
            <span style="display: flex; align-items: center;">
              {{ "companies.erp_id" | translate }}
            </span>
          </th>
          <th *ngIf="isColumnVisible('customer_groups')" class="is-left" [style.order]="columnOrderIndex('customer_groups')">{{ 'companies_groups.companies_groups' | translate }}</th>
          <th *ngIf="isColumnVisible('catalogs')" [style.order]="columnOrderIndex('catalogs')">
            <span style="display: flex; align-items: center;">
              {{ "Catalogs.catalogs" | translate }}
            </span>
          </th>
          <th *ngIf="isColumnVisible('total_orders')" [style.order]="columnOrderIndex('total_orders')">
            <span style="display: flex; align-items: center;">
              {{ "companies.total_orders" | translate }}
              <div class="sort-actions">
                <span class="arrow-up" [class.active]="activeSortBy == 'total_orders_count' && activeSortMode == 'asc'" (click)="sortBy('total_orders_count', 'asc')"></span>
                <span class="arrow-down" [class.active]="activeSortBy == 'total_orders_count' && activeSortMode == 'desc'" (click)="sortBy('total_orders_count', 'desc')"></span>
              </div>
            </span>
          </th>
          <th *ngIf="isColumnVisible('total_sales')" class="is-left" [style.order]="columnOrderIndex('total_sales')">
            <span style="display: flex; align-items: center;">
              {{ 'companies.total_sales' | translate }}
            </span>
          </th>
          <th *ngIf="isColumnVisible('last_order')" [style.order]="columnOrderIndex('last_order')">
            <span style="display: flex; align-items: center;">
              {{ 'companies.last_order' | translate }}
            </span>
          </th>
          <th *ngIf="isColumnVisible('last_activity')" class="is-left" [style.order]="columnOrderIndex('last_activity')">
            <span style="display: flex; align-items: center;">
              {{ "companies.last_activity" | translate }}
              <div class="sort-actions">
                <span class="arrow-up" [class.active]="activeSortBy == 'last_activity_date' && activeSortMode == 'asc'" (click)="sortBy('last_activity_date', 'asc')"></span>
                <span class="arrow-down" [class.active]="activeSortBy == 'last_activity_date' && activeSortMode == 'desc'" (click)="sortBy('last_activity_date', 'desc')"></span>
              </div>
            </span>
          </th>
          <th class="cell-actions" [style.order]="actionsColumnOrder"></th>
        </tr>
      </thead>

      <tbody class="customers-viewport">
        <ng-container *ngIf="displayCustomers$ | async as displayCustomers">
          <!-- Data rows -->
          <ng-container *ngIf="displayCustomers.length > 0">
            <ng-container *ngFor="let customer of displayCustomers; let i = index; trackBy: trackByCustomerId">
              <tr class="row body" [class.row-selected]="selection.isSelected(customer.id!)" [style.grid-template-columns]="gridTemplateColumns">
                <!-- Checkbox + Company Name -->
                <td class="cell-name" [style.order]="columnOrderIndex('name')">
                  <ui-checkbox
                    [checked]="selection.isSelected(customer.id!)"
                    [ariaLabel]="'common.select' | translate"
                    (changed)="selection.toggleOne(customer.id!, $event.checked, $event)">
                  </ui-checkbox>
                  <div class="company-name" (click)="openLocations(customer.locations![0])">
                    <span class="name-text">{{ customer.name }}</span>
                  </div>
                  <span *ngIf="customer.is_deleted && deletedFilter === 'all'" class="archived-tag">{{ 'common.archived' | translate }}</span>
                </td>

                <!-- Locations -->
                <td *ngIf="isColumnVisible('locations')" class="cell-locations" [style.order]="columnOrderIndex('locations')">
                  <img *ngIf="customer.locations && customer.locations.length > 0"
                      (click)="toggleVariants(customer.id!)"
                      [class]="expandedIndex === customer.id ? 'chevron chevron-up' : 'chevron'"
                      src="assets/icones/new-arrow-down.svg" alt="">
                  <span class="cell-value" (click)="openLocations(customer.locations![0])">
                    {{ customer.locations ? customer.locations.length : 0 }}
                  </span>
                </td>

                <!-- ERP ID -->
                <td *ngIf="isColumnVisible('erp_id')" (click)="openLocations(customer.locations![0])" class="cursor" [style.order]="columnOrderIndex('erp_id')">
                  <ui-copyable class="cell-value" [value]="customer.erp_id" [label]="'companies.erp_id' | translate">{{ customer.erp_id || '--' }}</ui-copyable>
                </td>

                <!-- Customer Groups -->
                <td *ngIf="isColumnVisible('customer_groups')" (click)="openLocations(customer.locations![0])" class="cursor cell-groups" [style.order]="columnOrderIndex('customer_groups')">
                  <div class="groups-container" *ngIf="customer.customer_groups && customer.customer_groups.length > 0; else noGroups">
                    <span class="tag-badge tag-blue" *ngFor="let group of customer.customer_groups">{{ group }}</span>
                  </div>
                  <ng-template #noGroups><span class="cell-value-muted">--</span></ng-template>
                </td>

                <!-- Catalogs -->
                <td *ngIf="isColumnVisible('catalogs')" (click)="openLocations(customer.locations![0])" class="cursor" [style.order]="columnOrderIndex('catalogs')">
                  <span class="cell-value">{{ customer.nbr_catalogs ?? 0 }}</span>
                </td>

                <!-- Orders -->
                <td *ngIf="isColumnVisible('total_orders')" (click)="openLocations(customer.locations![0])" class="cursor" [style.order]="columnOrderIndex('total_orders')">
                  <span class="cell-value">{{ customer.total_orders_count ?? 0 }}</span>
                </td>

                <!-- Total Sales -->
                <td *ngIf="isColumnVisible('total_sales')" (click)="openLocations(customer.locations![0])" class="cursor cell-sales" [style.order]="columnOrderIndex('total_sales')">
                  <span class="cell-value">{{ customer.total_sales != null ? (customer.total_sales | number:'1.2-2') + ' ' + getCompanyCurrencySymbol(customer) : '--' }}</span>
                </td>

                <!-- Last Order -->
                <td *ngIf="isColumnVisible('last_order')" (click)="openLocations(customer.locations![0])" class="cursor cell-last-order" [style.order]="columnOrderIndex('last_order')">
                  <span class="cell-value">{{ customer.last_order ? (customer.last_order | date: DATE_TIME_FORMAT) : '--' }}</span>
                </td>

                <!-- Last Activity -->
                <td *ngIf="isColumnVisible('last_activity')" (click)="openLocations(customer.locations![0])" class="cursor is-left" [style.order]="columnOrderIndex('last_activity')">
                  <div class="activity-cell" *ngIf="customer.activities && customer.activities.length > 0; else noActivity">
                    <div class="activity-main">
                      <mat-icon class="activity-icon">{{ getActivityIcon(customer.activities[0].activity) }}</mat-icon>
                      <span class="cell-value">{{ getActivityLabel(customer.activities[0].activity) }}</span>
                    </div>
                    <span class="activity-detail">{{ customer.activities[0].details || customer.activities[0].user }}</span>
                  </div>
                  <ng-template #noActivity><span class="activity-cell">--</span></ng-template>
                </td>

                <!-- Row actions menu (delete / restore) -->
                <td class="cell-actions" [style.order]="actionsColumnOrder">
                  <ng-container *ngIf="canEditOrDelete$ | async">
                    <button
                      mat-icon-button
                      class="companies__row-menu-trigger"
                      [matMenuTriggerFor]="rowMenu"
                      (click)="$event.stopPropagation()"
                      aria-label="Actions">
                      <mat-icon>more_horiz</mat-icon>
                    </button>
                    <mat-menu #rowMenu="matMenu" xPosition="before">
                      <button
                        *ngIf="!customer.is_deleted && (canDelete$ | async)"
                        mat-menu-item
                        (click)="delete(customer.id!)">
                        <mat-icon>delete_outline</mat-icon>
                        <span>{{ 'common.archive' | translate }}</span>
                      </button>
                      <button
                        *ngIf="customer.is_deleted && (canEdit$ | async)"
                        mat-menu-item
                        (click)="restore(customer.id!)">
                        <mat-icon>restore</mat-icon>
                        <span>{{ 'common.restore' | translate }}</span>
                      </button>
                    </mat-menu>
                  </ng-container>
                </td>
              </tr>

              <!-- Expanded location sub-rows: using customer.id (not index) ensures the correct
                  row stays open if the list re-renders due to a filter or load-more event. -->
              <ng-container *ngIf="expandedIndex === customer.id">
                <tr class="locations-scroll-host">
                  <td colspan="9" class="locations-scroll-cell">
                    <div class="locations-scroll">
                      <table class="locations-scroll-inner-table">
                        <tbody>
                          <tr *ngFor="let location of customer.locations" class="row body sub-row" [style.grid-template-columns]="gridTemplateColumns">
                            <td class="cell-name sub-cell-name" [style.order]="columnOrderIndex('name')">
                              <mat-icon class="sub-row-icon">subdirectory_arrow_right</mat-icon>
                              <div class="company-name" (click)="openLocations(location)">
                                <span class="name-text">{{ location.name }}</span>
                                <span class="name-sub">{{ location.apartment }}</span>
                              </div>
                            </td>
                            <td *ngIf="isColumnVisible('locations')" (click)="openLocations(location)" class="cursor" [style.order]="columnOrderIndex('locations')">
                              <div class="tags-container">
                                <span *ngIf="location.is_main" class="tag-badge tag-gray">{{ 'customers.main' | translate }}</span>
                                <span
                                  *ngIf="location.provenance?.source === 'volta'"
                                  class="volta-location-icon"
                                  [matTooltip]="'customers.contacts_tab.volta_location_tooltip' | translate"
                                  matTooltipClass="product-status-tooltip volta-location-tooltip"
                                  matTooltipPosition="above"
                                >
                                  <img src="assets/icones/volta_smal_icon.svg" alt="Volta" width="14" height="14">
                                </span>
                              </div>
                            </td>
                            <td *ngIf="isColumnVisible('erp_id')" (click)="openLocations(location)" class="cursor" [style.order]="columnOrderIndex('erp_id')">
                              <span class="cell-value">{{ location.erp_id || '--' }}</span>
                            </td>
                            <td *ngIf="isColumnVisible('customer_groups')" (click)="openLocations(location)" class="cursor cell-groups" [style.order]="columnOrderIndex('customer_groups')">
                              <div class="groups-container" *ngIf="location.customer_groups && location.customer_groups.length > 0; else noSubGroups">
                                <span class="tag-badge tag-blue" *ngFor="let group of location.customer_groups">{{ group }}</span>
                              </div>
                              <ng-template #noSubGroups><span class="cell-value-muted">--</span></ng-template>
                            </td>
                            <td *ngIf="isColumnVisible('catalogs')" (click)="openLocations(location)" class="cursor" [style.order]="columnOrderIndex('catalogs')">
                              <span class="cell-value">{{ location.nbr_catalogs ?? 0 }}</span>
                            </td>
                            <td *ngIf="isColumnVisible('total_orders')" (click)="openLocations(location)" class="cursor" [style.order]="columnOrderIndex('total_orders')">
                              <span class="cell-value">{{ location.total_orders_count || 0 }}</span>
                            </td>
                            <td *ngIf="isColumnVisible('total_sales')" (click)="openLocations(location)" class="cursor cell-sales" [style.order]="columnOrderIndex('total_sales')">
                              <span class="cell-value">{{ location.total_sales != null ? (location.total_sales | number:'1.2-2') + ' ' + (location.currency?.symbol || '€') : '--' }}</span>
                            </td>
                            <td *ngIf="isColumnVisible('last_order')" (click)="openLocations(location)" class="cursor cell-last-order" [style.order]="columnOrderIndex('last_order')">
                              <span class="cell-value">{{ location.last_order ? (location.last_order | date: DATE_TIME_FORMAT) : '--' }}</span>
                            </td>
                            <td *ngIf="isColumnVisible('last_activity')" [style.order]="columnOrderIndex('last_activity')"></td>
                            <td class="cell-actions" [style.order]="actionsColumnOrder"></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
        <!-- Empty state: kept inside .customers-viewport so it fills the scroll
             viewport's full height (.no_reseult height:calc(100% - 40px) resolves
             against the flex:1 tbody). Wrapped in <tr><td> for valid table DOM
             (a <div> is not a valid <tbody> child); the wrapper is display:block
             so it does not affect the grid row layout. Two variants: no companies
             exist at all vs. search/filter returned no results. -->
        <tr *ngIf="(customers$ | async)?.length === 0 && !(isAppLoading$ | async)" class="no-result-row">
          <td colspan="10">
            <div class="no_reseult">
              <ng-container *ngIf="!hasModuleFilters() && !key">
                <img src="assets/icones/no-companies_groups.svg" alt="">
                <h3>{{ "companies.no_companies" | translate }}</h3>
              </ng-container>
              <ng-container *ngIf="hasModuleFilters() || key">
                <img src="assets/icones/no-result-search.svg" alt="">
                <h3>{{ "companies.no_data_search" | translate }}</h3>
              </ng-container>
              <ng-container *appHasPermission="{ module: 'company', action: 'create' }">
                <button *ngIf="!hasModuleFilters() && !key" mat-icon-button class="action-btn primary-btn" (click)="addCustomers()">
                  <span class="icon"><app-svg-icon svgIcon="plus-cc"></app-svg-icon></span>
                  <span>{{ 'common.add' | translate | uppercase }}</span>
                </button>
              </ng-container>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- ─────────────────────────────────────────────────────────────────── -->
    <!-- Bulk actions for the current selection. Floats centred at the       -->
    <!-- bottom of the table, above the pagination row.                      -->
    <!-- ─────────────────────────────────────────────────────────────────── -->
    <ui-bulk-actions-bar *ngIf="selection.hasSelection" [count]="selection.count" (cleared)="selection.clear()">
      <button
        *appHasPermission="{ module: 'company', action: 'delete' }"
        class="ui-bulk-action ui-bulk-action--danger"
        (click)="deleteSelectedCustomers()"
      >
        <ui-icon name="Trash2" size="medium"></ui-icon>
        <span>{{ 'common.delete' | translate }}</span>
      </button>
    </ui-bulk-actions-bar>
    <!-- ── END BULK ACTIONS BAR ─────────────────────────────────────────── -->

    <app-pagination
      *ngIf="(customers$ | async)!.length > 0"
      class="customers-pagination"
      [pagination]="pagination$ | async"
      (toPageEvent)="toPage($event)"
    ></app-pagination>
  </div>
</div>
